export default __webpack_public_path__ + "static/media/image-2.27ace13a.jpg";